export default "__VITE_ASSET__BNQYoqOB__"